import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

const layers = [
  {
    name: '用户与角色层',
    icon: 'ri-team-line',
    items: ['消费者', '云社员', '云店长', '云创客', '供应链', '商家', '县域运营主体'],
  },
  {
    name: '业务场景层',
    icon: 'ri-store-3-line',
    items: ['数字买货', '数字卖货', '数字服务', '数字聚餐', '数字供应链', '数字消费权益'],
  },
  {
    name: '交易与权益层',
    icon: 'ri-arrow-left-right-line',
    items: ['商品', '订单', '支付', '权益', '红包', '履约', '评价', '清分'],
  },
  {
    name: '数字基础设施层',
    icon: 'ri-cpu-line',
    items: ['TOMA 智能体', '数字货架', 'ePin', '数字消费', '智能清分'],
  },
  {
    name: '平台治理层',
    icon: 'ri-shield-check-line',
    items: ['身份', '商品', '交易', '权益', '数据', '清分', '风控', '合规'],
  },
];

export default function TotalArchitecture() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="九畴云铺整体架构"
            title="从一个消费场景，到一套县域数字商业基础设施"
            subtitle="采用「5 层平台架构 + 1 条业务主链 + 1 张价值网络」的结构，完整呈现九畴云铺如何运行、如何治理、如何创造价值。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 space-y-3">
            {layers.map((l, i) => (
              <div
                key={l.name}
                className="rounded-lg border border-foreground-700 bg-foreground-900 p-5"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                    <i className={`${l.icon} text-accent-300 text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="font-heading font-bold text-background-50">
                      {l.name}
                    </div>
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    第 {i + 1} 层
                  </span>
                </div>
                <div className="mt-3 flex flex-wrap gap-2 pl-12">
                  {l.items.map((it) => (
                    <span
                      key={it}
                      className="px-3 py-1 text-xs rounded-full bg-background-50/10 border border-background-50/15 text-background-100 whitespace-nowrap"
                    >
                      {it}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { title: '5 层平台架构', desc: '用户 → 场景 → 交易 → 基础设施 → 治理' },
              { title: '1 条业务主链', desc: '从一件商品开始，跑通消费到产业闭环' },
              { title: '1 张价值网络', desc: '七方共利，消费 → 数据 → 产业 → 再消费' },
            ].map((c) => (
              <div
                key={c.title}
                className="p-6 rounded-lg border border-primary-500/30 bg-gradient-to-br from-primary-500/10 to-foreground-900 text-center"
              >
                <div className="font-heading font-bold text-primary-300">{c.title}</div>
                <div className="mt-2 text-sm text-foreground-300">{c.desc}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-8 text-center">
            <Link
              to="/jiuchou/architecture"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              查看五层平台架构详解
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}